<div class="container-fluid m-0 p-0">
    <div class="row">
        <!-- <div class="col-12 d-flex flex-wrap justify-content-between"> -->
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/schedule/schedule-setup-create"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                titlecase }}</button>
        </div> -->

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "SCHEDULE_SETUP_PREVIEW" | translate | titlecase }}- <a type="button" class="btn btn-primary" routerLink="/schedule/schedule-setup">{{
                        "BACK" | translate | titlecase }}</a></h5>

                <app-loader [show]="showLoader"></app-loader>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <!-- *ngIf="ScheduleData.length >= 1" -->
                    <table  class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <!-- <th>{{ ScheduleHeader[0] }}</th> -->
                                <th *ngFor="let res of ScheduleHeader">{{res}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of ScheduleData">

                                <th *ngFor="let colm of data">{{colm}}</th>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>